window._ = require('lodash');

import "@babel/polyfill";
import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import store from './store'

Vue.component('simulator', require('./components/Simulator.vue'))

window.app = new Vue({
  el: '#simulator-app',
  store,
  // data: {},
  // mounted() {},
  // computed: {},
  // methods: {},
})



// WEBPACK FOOTER //
// ./assets/js/app.js